/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './SchoolQuestion.module.scss'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearAllFieldsAction } from 'redux/actions'

const SchoolQuestionView = ({ t, i18n }) => {
  let history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(clearAllFieldsAction())
  }, [])

  const handleYes = () => {
    history.push(`/${i18n.language}${t('routes.driving_school_info')}`)
  }

  const handleNo = () => {
    history.push(`/${i18n.language}${t('routes.driver_info')}`)
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <div className={styles['margin_back']}>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <a
                  onClick={() => history.push(`/${i18n.language}${t('routes.fines_question')}`)}
                  href={`/${i18n.language}${t('routes.fines_question')}`}
                >
                  {t('fines_question.back')}
                  <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
                </a>
              </div>
            </div>
          </div>
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>{t('school_question.desc')}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <button className="btn-lg btn-default" onClick={handleYes} value={t('school_question.yes')} name={t('school_question.yes')}>
            {t('school_question.yes')}
          </button>
          <button
            className={['btn-lg btn-default', styles['margin_left_20']].join(' ')}
            onClick={handleNo}
            value={t('school_question.no')}
            name={t('school_question.no')}
          >
            {t('school_question.no')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(SchoolQuestionView)
